"use client";

import {
  Heart,
  Mail,
  Phone,
  MapPin,
  Linkedin,
  Twitter,
  Github,
} from "lucide-react";
import Logo from "./Logo";
import "./Footer.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import appConstants from "../shared/config/constants.json";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  const PRIVACY_URL =
    "https://docs.google.com/document/d/1GUX0DsM3OxqIOKnZVtKBBOp7HvMbLfetq-yqrPNgQqo/edit?tab=t.0#heading=h.hnmbcul91sh3";
  const TERMS_URL =
    "https://docs.google.com/document/d/1RN1r2ZiJ8uj6l-rIYqVCyxz-0GmDk9MY/edit?tab=t.0";
  const { MAYAMAYA_PROD_WHITELABEL_SUPPORT_URL } = appConstants;

  const navigate = useNavigate();
  const onNavigate = (page) => {
    console.log("Navigating to:", page);
    navigate(page);
  };

  const footerLinks = [
    {
      title: t("footer.sections.product"),
      links: [
        {
          name: t("footer.links.talentDevelopment"),
          action: () => onNavigate("/talent-development/upskill"),
        },
        {
          name: t("footer.links.leadershipProfiles"),
          action: () => onNavigate("/talent-development/leadership"),
        },
        {
          name: t("footer.links.internalMobility"),
          action: () => onNavigate("/talent-development/mobility"),
        },
        {
          name: t("footer.links.teamManagement"),
          action: () => onNavigate("/teams"),
        },
      ],
    },
    {
      title: t("footer.sections.resources"),
      links: [
        {
          name: t("footer.links.leadershipNominations"),
          action: () => onNavigate("/talent-development/nominations"),
        },
        {
          name: t("footer.links.mobilityReports"),
          action: () => onNavigate("/talent-development/recommendations"),
        },
        {
          name: t("footer.links.peopleSearch"),
          action: () => onNavigate("/employees"),
        },
        {
          name: t("footer.links.jobRoles"),
          action: () => onNavigate("/job-roles"),
        },
      ],
    },
    {
      title: t("footer.sections.legal"),
      links: [
        {
          name: t("footer.links.privacyPolicy"),
          action: () => onNavigate("/legal/privacy"),
        },
        {
          name: t("footer.links.termsConditions"),
          action: () => onNavigate("/legal/terms"),
        },
      ],
    },
  ];

  {
    /* { name: t("footer.links.cookiePolicy"), action: () => onNavigate("/legal/privacy") },
        { name: t("footer.links.dataSecurity"), action: () => onNavigate("/legal/privacy") }, */
  }

  const socialLinks = [
    {
      icon: Linkedin,
      href: "https://linkedin.com/company/talentconsole",
      label: "LinkedIn",
    },
    {
      icon: Twitter,
      href: "https://twitter.com/talentconsole",
      label: "Twitter",
    },
    { icon: Github, href: "https://github.com/talentconsole", label: "GitHub" },
  ];

  return (
    <footer className="main-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
              <Logo width={60} height={30} className="footer-logo-svg" />
              <span className="footer-logo-text">{t("footer.brand.name")}</span>
            </div>
            <p className="footer-description">
              {t("footer.brand.description")}
            </p>
            <div className="footer-contact">
              <div className="contact-item">
                <a
                  href={MAYAMAYA_PROD_WHITELABEL_SUPPORT_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "inherit", textDecoration: "none" }}
                >
                  {t("footer.contact.contactUs")}
                </a>
              </div>
              <div className="contact-item">
                <MapPin size={16} />
                <span>{t("footer.contact.address")}</span>
              </div>
            </div>
          </div>

          <div className="footer-links">
            {footerLinks.map((section) => (
              <div key={section.title} className="footer-section">
                <h4 className="footer-section-title">{section.title}</h4>
                <ul className="footer-section-links">
                  {section.links.map((link) => (
                    <li key={link.name}>
                      <button className="footer-link" onClick={link.action}>
                        {link.name}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-left">
            <p className="footer-copyright">
              © {t("footer.copyright", { year: currentYear })}{" "}
              <Heart size={14} className="heart-icon" />{" "}
              {t("footer.forBetterWorkplaces")}
            </p>
          </div>
          {/*<div className="footer-social">
            {socialLinks.map((social) => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label={social.label}
              >
                <social.icon size={18} />
              </a>
            ))}
          </div>*/}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
